export const CHART = ["#1F4D3A", "#35594A", "#9A6700", "#2B4C6F", "#A35D5D", "#7E8F7A", "#8FB5A0"];
export const GRID = "#EFEBE3";

export const CATEGORY_COLORS = {
  "Strong Fit": "#2F6B45", "Potential Fit": "#2B4C6F", "Needs Review": "#9A6700", "Not a Fit": "#8A8D85", "Not a Fit – Knockout": "#9B2C2C",
};

export const CATEGORY_CHIP = {
  "Strong Fit": "bg-success-tint text-success border-[#CADBCF]",
  "Potential Fit": "bg-info-tint text-info border-[#CDD7E2]",
  "Needs Review": "bg-caution-tint text-caution border-[#E8D7B0]",
  "Not a Fit": "bg-subtle text-ink-secondary border-line",
  "Not a Fit – Knockout": "bg-risk-tint text-risk border-[#E8C9C5]",
};

export const STAGES = [
  ["onboard", "Onboard"], ["screen_shortlist", "Screen and shortlist"], ["assess", "Assess"], ["interview", "Interview"], ["offer", "Offer"],
];
// eslint-disable-next-line no-unused-vars
export const stagesFor = (job) => STAGES;
export const stageLabel = (k) => (STAGES.find(([s]) => s === k) || [k, k])[1];

export const ChartTooltip = ({ active, payload, label, unit = "" }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="rounded-lg border border-line bg-white px-3 py-2 text-xs shadow-md tabular-nums">
      {label != null && <p className="mb-1 font-medium text-ink">{label}</p>}
      {payload.map((p) => <p key={p.dataKey || p.name} className="text-ink-secondary">{p.name}: <span className="font-medium text-ink">{p.value}{unit}</span></p>)}
    </div>
  );
};

export const ChartCard = ({ title, takeaway, children, testId }) => (
  <section className="panel space-y-2 p-5" data-testid={testId} role="figure" aria-label={takeaway ? `${title}. ${takeaway}` : title}>
    <h3 className="text-base font-semibold">{title}</h3>
    {takeaway && <p className="text-sm text-ink-secondary" data-testid={`${testId}-takeaway`}>{takeaway}</p>}
    <div className="pt-2">{children}</div>
  </section>
);
